//
// ImageCache.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";

var ImageCache = createModule("commons::ImageCache", [], ClosetObject, [
    ,
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default ImageCache;
